












































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { store, CDR, StoreState } from '../../store';
import VueElementLoading from 'vue-element-loading';
import {RotateSquare2} from 'vue-loading-spinner';
import { mapState } from 'vuex';
import ManagingTag from  '../Tag/ManaginTag.vue';
import { utils } from 'xlsx/types';
import utill from '../../lib/util'; 
// import { use } from 'vue/types/umd';
import util from "../../lib/util";

@Component({
  components: {
      RotateSquare2,VueElementLoading,ManagingTag
},
computed: {
...mapState({
 'devices': (state: StoreState) => (state.account as any).devices,
 'Tag_status': (state: StoreState) => state.dashboard.Tag_status,
 'Tab_Mang': (state: StoreState) => state.dashboard.Tab_Mang,
 'PersonalContact_Count': (state: StoreState) => state.dashboard.PersonalContact_Count,
 'User_id': (state: StoreState) => state.dashboard.logger_userid ,
 'Tag_list_': (state: StoreState) =>state.dashboard.Tag_list,
 'NewTags': (state: StoreState) =>state.dashboard.NewTags,
 'handletagsidebar' : (state: StoreState) => state.dashboard.handletagsidebar
 })
},
mounted: function() {
  if(localStorage.mobileNumber)
  {
    this.$data.Contact_New.mobile = localStorage.mobileNumber;
    localStorage.mobileNumber = "";
  }
  else
  {
    this.$data.Contact_New.mobile = "";
  }
},
})
export default class CONTACTNEW extends Vue {

    @Prop()
    public newnumber;

  data() {
   return {
    is_loading: false,
    newimagUploading:false,
    selectedDevice: null,
    activetab: 'details',
    managintab:false,
    submitted: false,
    profImag:'',
    imageupload:false,
    Number_status:true,
    email_status:false,
    address_invalid:false,
    home_status:false,
    mobile_status:false,
    favo_cont:false,
    clickstatus:false,
    Assigned_tag:'',
    contac_tag:[],
    form_validation: {
                mobile: {
                  is_exist:false
                },
                email: {
                  is_exist:false
                }
              },
    Contact_New: {
      first_Name  : '',
      last_Name   : '',   
      mobile      : this.$props.newnumber,//localStorage.mobileNumber? localStorage.mobileNumber : '',
      work        : [ { work: '', extension: '' }], 
      home        :'',
      company_name: '',
      address_    :'',
      email       :'',
      customer_Id :'',  
        },  
      error_message:false,
   }
  }

  addd_work(){
    this.$data.Contact_New.work.push({work:'',extension:'' ,delet:true})
  }
  workdatacheck()
  {
    if(this.$data.Contact_New.work.length == 0)
      return false;
    let return_var = false;
     for(let i = 0; i < this.$data.Contact_New.work.length; i++)
       if(this.$data.Contact_New.work[i].work)
       {
          return_var = true;
       }
    return return_var;
  }
  getTagbyId(tagid)
{
  // console.log(tagid);
  let tags = util.handletag();
  // console.log(tags);
  // console.log(tags.map(e=>e._id));
  if(tags.map(e=>e._id).indexOf(tagid) > -1) return { type: "tag", tag: tags[tags.map(e=>e._id).indexOf(tagid)] }
  return {type: "empty", tag: {}};
}
   @Watch('Tag_status')
  onChangetagstaus()
  {
    if(!(this as any).Tag_status)
    {
        this.$data.managintab = false;
    }
  }

  @Watch('NewTags')
  oncreate(){
    (this as any).Tag_list_.forEach((e1)=>(this as any).NewTags.forEach((e2)=> {
        if(e1._id === e2){
      if(this.$data.contac_tag.length!=0){
      this.$data.contac_tag.push(e1._id);
      }
      else{
        this.$data.contac_tag=[e1._id];
      }
        }
    }
    ));
  }
   workdataeditcheck(index = -1)
  {
    let faultyindex = [];
    if(this.$data.Contact_New.work.length == 0)
      return false;
    let return_var = false;
     for(let i = 0; i < this.$data.Contact_New.work.length; i++)
       if(!(this.validatePhoneNumber(this.$data.Contact_New.work[i].work) != "Invalid number"))
       {
          return_var = true;
           faultyindex.push(i);
       }
    return {type: return_var, ids: faultyindex, position: faultyindex.indexOf(index)};
  }
   
   validateAlphanumberic(event) {
     
     
        const regex = /^[A-Za-z0-9 (),#-.;&']+$/i;
       var key = String.fromCharCode(event.charCode ? event.which : event.charCode);
       console.log(regex.test(key));
      
      if (regex.test(key)) {
           if(event.which==36 || event.which==37 || event.which==43 || event.which==42) {
              event.preventDefault();
              return false;
           }
          return true;
      } else {
        event.preventDefault();
        return false;
      }
      
   }
   validateAddress(address:any) {
        
        const re =/^[A-Za-z0-9 (),#-.;&'\s]+$/i;
        if(!re.test(address)) {
                return false;
            }
        return true;
    }
   
   validateEmail(email: any) {
        //Breakdown of this Regex can be found here:
        //https://www.w3resource.com/javascript/form/email-validation.php
        //Seems to cover most all cases.
          const re =/^(([^<>()\[\]\\.,!;:\s@"]+(\.[^<>()!\[\]\\.,;:\s@"]+)*)|("!.+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;// /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if(!re.test(email)) {
                return false;
            }
        return true;
      }

        handlecustomdd() //type, index
    { 
    
    // let classstatus = document.querySelector(".mtagclass");
        let tag_svgGreen = document.querySelector(".tag_svgGreen");
        if(  tag_svgGreen && this.$data.managintab && !this.$data.clickstatus)
        {
          this.$data.managintab = false;
        }
        else
        {
          this.$data.clickstatus = false;
        }
    
    }
    
   delete_work(index){
    this.$data.Contact_New.work.splice(index, 1);  
  }
  keyUpValidation($event,field_name) {
    this.$data.form_validation.mobile.is_exist=false;
    this.$data.form_validation.email.is_exist=false;
    this.$data.error_message = false;
  }
  validatePhoneNumber(phoneNumber: any) {
    
    if(!phoneNumber) return true;
    if(phoneNumber.toString().indexOf("+1") > -1) phoneNumber = phoneNumber.toString().replace("+1", '');
     if(typeof phoneNumber === "number") {
                phoneNumber = phoneNumber.toString();
            } 
            if(phoneNumber.length != 10) return "Invalid number";      
            const re = /(?:\+1)?(\d{3})(\d{3})(\d{4})/;
            const matches = phoneNumber.match(re);
            if(matches === null) {
              this.$data.Number_status = false;
                    console.log("The phone number " + phoneNumber + " could not be parsed");
                return "Invalid number";
            }           
            return `(${matches[1]}) ${matches[2]}-${matches[3]}`;
  }
  validat_num(Number: any){
       let mob_number = Number//this.$data.NewContact_User.mobile;
           mob_number = mob_number.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '').replace(/-/g, '').replace(/\+/, '');
        if(mob_number.length === 10) {
           mob_number = `+1${mob_number}`;
         }
        else {
            mob_number = `+${mob_number}`;
        }
        return mob_number;
            //this.$data.NewContact_User.mobile=mob_number;
    }

  profile_upload(file) {
        // To check if file is an image
        if (!file.target.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
            alert('not an image');
            file.target.value = null
            // this.$emit('imageChanged', null)
            return;
        }
        this.$data.newimagUploading = true;
        this.$data.Newcropped_status=true;
        var reader = new FileReader();
        reader.readAsDataURL(file.target.files[0]);
        reader.onload = () => {
            this.$data.dialog = true;
            this.$data.profImag= reader.result;
            this.$data.imageupload=true;
            file.target.value = null;
             setTimeout(function()
          {
              this.$data.newimagUploading = false;
          }.bind(this),1000)
            
        };
        reader.onerror = (error) => {
            console.log('Error: ', error);
        };
    }

     getColor(user)
    {  
      //alert(user.tag +' '+ user._id)
       return utill.userColor(user.tag , user._id);
    }

  
  newcontact_tag(tag ,evt){
   // this.$data.Assigned_tag=tag._id;
    var found = (this as any).Tag_list_.find(function(element) {
        return element._id ==tag._id;
      });
      found.select=evt=="assign"?true:false;
      this.$data.Assigned_tag=evt=="assign"?tag._id:"";
      this.$data.managintab=false;
      if(evt=="assign"){
        if(this.$data.contac_tag.length!=0){
       this.$data.contac_tag.push(tag._id);
        }
        else{
          this.$data.contac_tag=[tag._id];
        }
      }
      else{
      var inx;
    //   this.$data.contac_tag.filter(function (el,index) { 
    //     if(el._id === tag._id){
    //       inx=index;
    //     }
    //  });
    inx = this.$data.contac_tag.indexOf(tag._id)
     this.$data.contac_tag.splice(inx,1); 
      }
      console.log("contac_tag --- ", this.$data.contac_tag);
  }

  _SubmitContact_new(e){
      this.$data.submitted = true;
      var mobile_status=false;
      var work_status = false;
      var email_status=false;
      var home_status = false;
      var number_val = false;
      let address=false;
      let work = JSON.parse(JSON.stringify(this.$data.Contact_New.work));
     this.$validator.validate().then(async valid => {
      if(valid)
      if(this.$data.Contact_New.email != '' && this.validateEmail(this.$data.Contact_New.email) )
        {
           this.$data.email_status=true;
        }
        if(this.$data.Contact_New.address_!='' && this.validateAddress(this.$data.Contact_New.address_)) {
          this.$data.address_invalid = true;
        }
        let wordvalidate = this.workdataeditcheck();
        let workval = JSON.parse(JSON.stringify(wordvalidate)).type;
        let workpos = JSON.parse(JSON.stringify(wordvalidate)).position;
        let homevalidate = this.$data.Contact_New.home  ? !(this.validatePhoneNumber( this.$data.Contact_New.home) != 'Invalid number' ): (this.$data.Contact_New.mobile || this.workdatacheck()) ? false : true; 
        let workvalidate = this.workdatacheck() ? !(workval ? false : true  ): (this.$data.Contact_New.home || this.$data.Contact_New.mobile) ? false : true;
        //let mobilevalidate =this.$data.Contact_New.mobile  ? !(this.validatePhoneNumber( this.$data.Contact_New.mobile) != 'Invalid number' ): (this.$data.Contact_New.home || this.workdatacheck()) ? false : true;
        let mobilevalidate =this.$data.Contact_New.mobile  ? !(this.validatePhoneNumber( this.$data.Contact_New.mobile) != 'Invalid number' ):  true;
        if(!homevalidate && !workvalidate && !mobilevalidate)
        {
           number_val = true;
        } 
          console.log('workvalidate',workvalidate);
          console.log('homevalidate',homevalidate);
          console.log('mobilevalidate',mobilevalidate);
          console.log('number_val',number_val);
         //return false;
        if((this.$data.email_status == true || this.$data.Contact_New.email == '' || this.$data.Contact_New.email==undefined) && (this.$data.address_invalid || this.$data.Contact_New.address_=='') )  {           
        if((number_val && valid)){  
          let work1 = [];
          if(work.length == 0)
          {
            work1 = [];
            work1.push({work:'',extension:''})
          }
          else
          {
            work.forEach(element => {
              if(element.work) work1.push(element);
            });
          }
          if(work1.length == 0)
          {
            work1.push({work:'',extension:''})
          }
            this.$data.is_loading = true; 
            
          var Newcontact_data:any= {
          fname        :  this.$data.Contact_New.first_Name,
          lname        :  this.$data.Contact_New.last_Name,
          companyname  :  this.$data.Contact_New.company_name,
          home         :  this.$data.Contact_New.home,
          work         :  work1,
          mobile       :  this.$data.Contact_New.mobile,
          custermerid  :  this.$data.Contact_New.custermer_Id,
          address      :  this.$data.Contact_New.address_,
          email        :  this.$data.Contact_New.email,
          imageUrl     :  (this as any).imageupload?(this as any).profImag:'',
          private:true,
          
      } 
      var USERID=(this as any).User_id;
      if(this.$data.favo_cont){
        Newcontact_data.Favoritecontact =[USERID];
      }
      if(this.$data.contac_tag.length==0){
      Newcontact_data.taglist = [];
      }
      else{
         Newcontact_data.taglist = this.$data.contac_tag;
      }
      this.updatetaglist(Newcontact_data.taglist, []);
        }        
        }
        //Important dont remove
        Newcontact_data.mobile=Newcontact_data.mobile;

       await this.$store.dispatch('addCaller', Newcontact_data).then(r => {
             console.log('r data',r);
            if(r && r.data && r.data.status==403) { console.log('here');
               this.$data.is_loading = false; 
               if(r.data.field_failed=='mobile') {
                  this.$data.form_validation.mobile.is_exist=true;
               }
               if(r.data.field_failed=='email') {
                  this.$data.form_validation.email.is_exist=true;
               }
               
               this.$data.error_message = true;
               console.log('ismobileexist',this.$data.form_validation);
            } else { console.log('adding caller to contact');
              this.$store.commit('CONTACT_SIDEBARSTATSU', 'personal');
              this.$data.form_validation.mobile.is_exist = false;
              this.$data.form_validation.email.is_exist=false;
              this.$emit('newcontactclose');
              this.$emit('refreshlist','refresh_listdata');
              this.$data.is_loading = false;  
            }
            
        })
       .catch(() => { console.log('failing here adding caller to contact');
           this.$data.is_loading = false;  
           this.$data.form_validation.mobile.is_exist=false;
           this.$data.form_validation.email.is_exist=false;
        });                                                                    
     })
   
  }
  

  mange_tag(type){
    
       setTimeout(function(){
      this.$store.commit('MANAGING_TAG','newContact_tag');
    if(type == "open")
    {
      this.$data.managintab = true;  
    }
    else
    {
      this.$data.managintab = false;
    }
    }.bind(this), 500);
    var id=this.$data.Assigned_tag;
       if(this.$data.contac_tag.length!=0){
      (this as any).Tag_list_.forEach((e1)=>this.$data.contac_tag.forEach((e2)=> {
          if(e1._id === e2._id){
          e2.select=true;
          }
      }
      ));
      }
  }
  updatetaglist(add, remove)
{
    console.log(add);
    console.log(remove);
    let tags = utill.handletag();
    if(add.length > 0)
    {
      for(let i = 0; i < add.length; i++)
      {
        tags[tags.map(e=>e._id).indexOf(add[i])].contact_count += 1;
      }
    }
    if(remove.length > 0)
    {
      for(let i = 0; i < remove.length; i++)
      {
        tags[tags.map(e=>e._id).indexOf(remove[i])].contact_count -= 1;
      }
      utill.handletag(tags, 'set');

      this.$store.commit('HANDLE_TAG_SIDEBAR' ,!(this as any).handletagsidebar);
    }
    
}

}
